import { schema } from 'normalizr';
import { schemas as contentSchemas } from 'edrolo/reducers/content';

export const reducerKeys = {
  USER_BOOKMARK: 'bookmarks',
  COURSE_PROGRESS: 'courseProgress',
  STUDENT_LESSON_PROGRESS: 'studentLessonProgress',
  STUDENT_SITTING_PROGRESS: 'studentSittingProgress',
  CLASS_PROGRESS: 'classProgress',
  TEACHER_NOTE: 'teacherNotes',
  CLASS_LESSON_PROGRESS: 'classLessonProgress',
  CLASS_LESSON_AVERAGE: 'classLessonAverage',
  CLASS_DETAIL: 'classDetail',
  PRIVILEGED_CONTENT: 'privilegedContent',
  FLAG: 'flags',
  USER: 'users',
  ENROLMENT: 'enrolments',
  PROFILE: 'profiles',
  ROLE: 'roles',
};

const edroloSchemas = {
  userBookmark: new schema.Entity(
    reducerKeys.USER_BOOKMARK,
    {},
    { idAttribute: 'chunk_pk' }
  ),
  courseProgress: new schema.Entity(
    reducerKeys.COURSE_PROGRESS,
    {},
    { idAttribute: 'course_id' }
  ),
  studentSittingProgress: new schema.Entity(
    reducerKeys.STUDENT_SITTING_PROGRESS,
    {},
    { idAttribute: 'exam' }
  ),
  classProgress: new schema.Entity(
    reducerKeys.CLASS_PROGRESS,
    {},
    { idAttribute: 'school_class_id' }
  ),
  classDetail: new schema.Entity(reducerKeys.CLASS_DETAIL),
  user: new schema.Entity(reducerKeys.USER),
  enrolment: new schema.Entity(reducerKeys.ENROLMENT),
  profile: new schema.Entity(reducerKeys.PROFILE),
  role: new schema.Entity(reducerKeys.ROLE),

  // children - usually accessed via array on parent schema
  studentLessonProgress: new schema.Entity(
    reducerKeys.STUDENT_LESSON_PROGRESS,
    {},
    { idAttribute: 'stache_id' }
  ),
  classLessonAverage: new schema.Entity(
    reducerKeys.CLASS_LESSON_AVERAGE,
    {},
    { idAttribute: 'lesson_id' }
  ),

  // nested / dual key entities
  classLessonProgress: new schema.Entity(
    reducerKeys.CLASS_LESSON_PROGRESS,
    {},
    { idAttribute: 'lesson_id' }
  ), // nested under classId
  privilegedContent: new schema.Entity(
    reducerKeys.PRIVILEGED_CONTENT,
    {},
    { idAttribute: 'class_id' }
  ),
  teacherNote: new schema.Entity(reducerKeys.TEACHER_NOTE),
};

edroloSchemas.user.define({
  enrolments: new schema.Array(edroloSchemas.enrolment),
  roles: new schema.Array(edroloSchemas.role),
});

edroloSchemas.privilegedContent.define({
  exams: new schema.Array(contentSchemas.exam),
  lesson_resources: new schema.Array(contentSchemas.lessonResource),
  course_resources: new schema.Array(contentSchemas.courseResource),
  teacher_notes_for_students: new schema.Array(edroloSchemas.teacherNote),
});

edroloSchemas.courseProgress.define({
  lessons: new schema.Array(edroloSchemas.studentLessonProgress),
  sittings: new schema.Array(edroloSchemas.studentSittingProgress),
});

edroloSchemas.classProgress.define({
  lessons: new schema.Array(edroloSchemas.classLessonAverage),
});

edroloSchemas.classLessonProgress.define({
  student_progress: new schema.Array(edroloSchemas.studentLessonProgress),
  class_averages: new schema.Array(edroloSchemas.classLessonAverage),
});

edroloSchemas.enrolment.define({
  profile: edroloSchemas.profile,
});

edroloSchemas.classDetail.define({
  enrolments: new schema.Array(edroloSchemas.enrolment),
});

export default edroloSchemas;
